module.exports = __webpack_public_path__ + "static/media/f12bcf58.jpg";